@if (option) {
    <div class="flex-row gap-10">
        <div class="voteBlock">
            @if (option.nested_multiple_choices) {
                <mat-checkbox #opt1 (change)="setResult.emit(true)"
                              [checked]="option?.nestedResults?.includes(nestedOption.id)"
                              [disableRipple]="true"
                              [disabled]="preview || maxNestedOptionsCheck()"
                              [hidden]="showResult"
                              [value]="nestedOption.id"
                              color="accent">
                </mat-checkbox>
            }
            @if (!option.nested_multiple_choices) {
                <mat-radio-button #opt2 (change)="setResult.emit(false)"
                                  [checked]="option?.nestedResults?.includes(nestedOption.id)"
                                  [disableRipple]="true"
                                  [disabled]="preview"
                                  [hidden]="showResult"
                                  [name]="'nestedPollOption-' + option.id"
                                  [value]="nestedOption.id"
                                  color="accent">
                </mat-radio-button>
            }
        </div>
        <ng-content></ng-content>
    </div>
}
